import React, { useEffect, useState } from 'react';
import { HeaderBox } from './mBookListPage';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import { ArrowBackIos } from '@mui/icons-material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18n, { _get_i18Lang } from '../../i18n';
import VideosService from "../../Services/VideoPlayer";

const MbVideoParentCategory = () => {
  const navigate = useNavigate();
  const [videoCategories, setVideoCategories] = useState<any[]>([]);
  const [recordCounts, setRecordCounts] = useState<{ [key: string]: number }>({});
  const { t } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const language = _get_i18Lang();
        const response: any = await VideosService.getMbCategories(language);
        if (response.result) {
          setVideoCategories(response.result);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [i18n.language]);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const response: any = await VideosService.getCategories(_get_i18Lang());
        if (response?.result) {
          const counts: { [key: string]: number } = {};
          response.result.forEach((item: any) => {
            counts[item.id] = item.count || 0;
          });
          setRecordCounts(counts);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchCounts();
  }, [i18n.language]);

  const getTotalRecordCount = (): number => {
    return videoCategories.reduce((sum, item) => sum + (recordCounts[item?.id] || 0), 0);
  };

  return (  
    <>      
      <HeaderBox>
        <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
          <ArrowBackIos sx={{ color: "white", fontSize: '18px' }} />
        </IconButton>
        <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
          <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
        </IconButton>
        <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
          {t("shrihari_tr")}  
        </Typography>
        <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
          {t("Video_tr")}
        </Typography>
      </HeaderBox>

      {/* 2-column grid */}
        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            mt: 0.5,
            fontWeight: 500,
            fontFamily: "chanakyaUni",
            fontSize: 16,
            height: 15,
            padding: -3
          }}
        >
          Total Records: {getTotalRecordCount()}
        </Typography>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "10px",
          padding: "10px"
        }}
      >
        {videoCategories.map((item: any, index: number) => (
          <React.Fragment key={item?.id ?? index}>

            <div style={{ textAlign: "center", }}>
              <div
                style={{
                  backgroundColor:"rgb(249 115 22 / 22%)",
                  height: '8px',
                  borderTopRightRadius: '10px',
                  borderTopLeftRadius: '10px',
                  width: "80%",
                  margin: "0 auto", 
                  marginBottom:"-3.5px"
                }}
              ></div>
                <div
                style={{
                  backgroundColor: "#f97316",
                  height: '5.5px',
                  borderTopRightRadius: '10px',
                  borderTopLeftRadius: '10px',
                  width: "90%",
                  margin: "0 auto",
                  opacity:0.6
                }}
              ></div>
              <img
                src={item.categoryThumbPath}
                alt={`Category ${index}`}
                style={{ width: "100%", borderRadius: "8px" }}
                onClick={()=>navigate("/videos",{state:{id:item?.id}})}
              />
             <p style={{fontWeight:600,paddingTop:3,margin:'0 auto',color:"#301934"}}> {item?.name} </p>
            </div>


          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default MbVideoParentCategory;
